import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import JsonExcel from 'vue-json-excel'
import moment from 'moment'

// // Import the Auth0 configuration
// import { domain, clientId } from "../auth_config.json";

// // Import the plugin here
// import { Auth0Plugin } from "./auth";

// // Install the authentication plugin here
// Vue.use(Auth0Plugin, {
//   domain,
//   clientId,
//   onRedirectCallback: appState => {
//     router.push(
//       appState && appState.targetUrl
//         ? appState.targetUrl
//         : window.location.pathname
//     );
//   }
// });

// 路由拦截
router.beforeEach((to,from,next) => {
  if(to.path === '/login') return next()
  const a = window.localStorage.getItem('un');
  if(!a) return next('/login')
  next()
})

Vue.component('downloadExcel',JsonExcel)

Vue.config.productionTip = false

Vue.use(ElementUI)

import service from '../service'
 // 挂载到原型,可在全局使用
Vue.prototype.service = service

Vue.prototype.$moment = moment

new Vue({
    router,
  render: h => h(App),
}).$mount('#app')
